import React, { useCallback } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import MonitorService from 'src/controllers/MonitorService';
import ChatsService from "src/controllers/ChatController";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const TransferButton = React.memo(({ call, userId, type, token }) => {
    const { t } = useTranslation();

    const handleSend = useCallback((e) => {
        e.preventDefault();

        if (type === 'call') {
            const callToTransfer = {
                ext: call.ext?.trim() || call.portExt,
                callId: call.id,
                pin: userId,
                status: call.status,
                forceTransfer: false
            };

            MonitorService.transferCallToAgent(token, callToTransfer, () => { });

        } else {
            var id = call.conversationId || call.guid || call.chatGuid;
            ChatsService.transferChat(userId, null, id, null, () => { });
        }
    }, [call, userId, type, token]);

    return (
        <Button variant="light-primary" size="xs" onClick={handleSend} title={t("transfertome")}>
            <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} />
        </Button>
    );
});

export default TransferButton;